export default {
  install (Vue, options) {
    Vue.prototype.$formatDate = function (value) {
      var date = new Date();
      date.setTime(value);
      var month = date.getMonth() + 1;
      var hours = date.getHours();
      if (hours < 10) hours = '0' + hours;
      var minutes = date.getMinutes();
      if (minutes < 10) minutes = '0' + minutes;
      var time = date.getFullYear() + '-' + month + '-' + date.getDate() + ' ' + hours + ':' + minutes;
      return time;
    },
	Vue.prototype.$getType = function (type) {
		if(type == 'P100'){
			return '迪亚士';
		}else if(type == 'P200'){
			return '达伽马';
		}else if(type == 'P300'){
			return '麦哲伦';
		}else if(type == 'P500'){
			return '詹姆斯';
		}else if(type == 'P1000'){
			return '哥伦布';
		}else{
			return '--';
		}
	}
  }
}